import getOcTheme from '../../../theme/services/getOcTheme';

const { palette, shape } = getOcTheme();

// unfortunately, IE still can't display svg background as it (see http://codepen.io/tigt/post/optimizing-svgs-in-data-uris)
// switching to base 64 for now
// const ICON_INFORMATION = '<svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'><path fill='%233fa5db' d='M26.4 22.2c1-1.9 1.6-4 1.6-6.3 0-7.6-6.2-13.8-13.8-13.8s-13.8 6.2-13.8 13.8 6.2 13.8 13.8 13.8c3.5 0 6.7-1.3 9.2-3.5l7.2 2-4.1-5.9zM13.4 22.3c0.1 0.1 0.2 0.1 0.3 0.1 0.1 0 0.3-0.1 0.5-0.2 0.5-0.4 1-1 1.6-1.7l0.5 0.3c-0.6 0.9-1.3 1.7-2.2 2.4-0.6 0.5-1.2 0.7-1.8 0.7-0.4 0-0.7-0.1-0.9-0.3s-0.4-0.5-0.4-0.8c0-0.3 0.1-0.9 0.3-1.7l1.8-6.1c0.3-1 1-3.4 1-3.4l2.1-0.3-2.7 9.6c-0.2 0.6-0.3 1-0.3 1.2 0 0.1 0 0.3 0.1 0.4zM17 8.1c-0.3 0.3-0.6 0.4-1 0.4s-0.7-0.1-1-0.4c-0.3-0.3-0.4-0.6-0.4-1 0-0.4 0.1-0.7 0.4-1 0.3-0.3 0.6-0.4 1-0.4s0.7 0.1 1 0.4c0.3 0.3 0.4 0.6 0.4 1 0 0.4-0.1 0.7-0.4 1z'/></svg>';
// const ICON_QUESTION = '<svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'><path fill='%23565656' d='M26.4 22.2c1-1.9 1.6-4 1.6-6.3 0-7.6-6.2-13.8-13.8-13.8s-13.8 6.2-13.8 13.8 6.2 13.8 13.8 13.8c3.5 0 6.7-1.3 9.2-3.5l7.2 2-4.1-5.9zM13.2 22.6c-0.7 0-1.2-0.6-1.2-1.3 0-0.8 0.6-1.5 1.4-1.5 0.7 0 1.2 0.6 1.2 1.3 0 0.8-0.6 1.4-1.4 1.4zM16.6 14.4c-1.1 1.1-1.6 2-1.7 3.2 0 0.2-0.1 0.4-0.1 0.6h-1.8c0-0.2 0-0.4 0-0.6 0.1-1.2 0.7-2.5 2.1-4 1-1 1.9-2 1.9-3.2 0-0.8-0.4-1.5-1.7-1.5-0.8 0-1.6 0.2-2.2 0.6l-0.3-1.3c0.8-0.5 1.8-0.8 3-0.8 2.1 0 3.1 1.4 3.1 2.7 0 1.7-1.1 3-2.4 4.3z'/></svg>';
// const ICON_WARNING = '<svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'><path fill='%23f39539' d='M26.4 22.2c1-1.9 1.6-4 1.6-6.3 0-7.6-6.2-13.8-13.8-13.8s-13.8 6.2-13.8 13.8 6.2 13.8 13.8 13.8c3.5 0 6.7-1.3 9.2-3.5l7.2 2-4.1-5.9zM12.7 22.6c-0.7 0-1.2-0.6-1.2-1.3 0-0.8 0.6-1.5 1.4-1.5 0.7 0 1.2 0.6 1.2 1.3 0 0.8-0.6 1.4-1.4 1.4zM14.1 18.1h-1.4l1.7-10.5h2.1l-2.3 10.5z'/></svg>';
// const ICON_ERROR = '<svg xmlns='http://www.w3.org/2000/svg' width='32' height='32' viewBox='0 0 32 32'><path fill='%23c21936' d='M26.4 22.2c1-1.9 1.6-4 1.6-6.3 0-7.6-6.2-13.8-13.8-13.8-7.6 0-13.8 6.2-13.8 13.8s6.2 13.8 13.8 13.8c3.5 0 6.7-1.3 9.2-3.5l7.2 2-4.1-5.9zM17.7 19.6h-2.5l-0.5-1.2c-0.2-0.6-0.4-1-0.5-1.4h-0.1c-0.2 0.4-0.4 0.8-0.8 1.3l-0.9 1.4h-2.6l3.4-4-1.8-3.8h2.5l0.5 1.2c0.2 0.6 0.4 1 0.5 1.3h0c0.3-0.4 0.5-0.8 0.8-1.2l0.9-1.2h2.6l-3.3 3.8 1.8 4z'/></svg>';

const ICON_INFORMATION =
  'PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPSczMicgaGVpZ2h0PSczMicgdmlld0JveD0nMCAwIDMyIDMyJz48cGF0aCBmaWxsPScjM2ZhNWRiJyBkPSdNMjYuNCAyMi4yYzEtMS45IDEuNi00IDEuNi02LjMgMC03LjYtNi4yLTEzLjgtMTMuOC0xMy44cy0xMy44IDYuMi0xMy44IDEzLjggNi4yIDEzLjggMTMuOCAxMy44YzMuNSAwIDYuNy0xLjMgOS4yLTMuNWw3LjIgMi00LjEtNS45ek0xMy40IDIyLjNjMC4xIDAuMSAwLjIgMC4xIDAuMyAwLjEgMC4xIDAgMC4zLTAuMSAwLjUtMC4yIDAuNS0wLjQgMS0xIDEuNi0xLjdsMC41IDAuM2MtMC42IDAuOS0xLjMgMS43LTIuMiAyLjQtMC42IDAuNS0xLjIgMC43LTEuOCAwLjctMC40IDAtMC43LTAuMS0wLjktMC4zcy0wLjQtMC41LTAuNC0wLjhjMC0wLjMgMC4xLTAuOSAwLjMtMS43bDEuOC02LjFjMC4zLTEgMS0zLjQgMS0zLjRsMi4xLTAuMy0yLjcgOS42Yy0wLjIgMC42LTAuMyAxLTAuMyAxLjIgMCAwLjEgMCAwLjMgMC4xIDAuNHpNMTcgOC4xYy0wLjMgMC4zLTAuNiAwLjQtMSAwLjRzLTAuNy0wLjEtMS0wLjRjLTAuMy0wLjMtMC40LTAuNi0wLjQtMSAwLTAuNCAwLjEtMC43IDAuNC0xIDAuMy0wLjMgMC42LTAuNCAxLTAuNHMwLjcgMC4xIDEgMC40YzAuMyAwLjMgMC40IDAuNiAwLjQgMSAwIDAuNC0wLjEgMC43LTAuNCAxeicvPjwvc3ZnPg==';
const ICON_QUESTION =
  'PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPSczMicgaGVpZ2h0PSczMicgdmlld0JveD0nMCAwIDMyIDMyJz48cGF0aCBmaWxsPScjNTY1NjU2JyBkPSdNMjYuNCAyMi4yYzEtMS45IDEuNi00IDEuNi02LjMgMC03LjYtNi4yLTEzLjgtMTMuOC0xMy44cy0xMy44IDYuMi0xMy44IDEzLjggNi4yIDEzLjggMTMuOCAxMy44YzMuNSAwIDYuNy0xLjMgOS4yLTMuNWw3LjIgMi00LjEtNS45ek0xMy4yIDIyLjZjLTAuNyAwLTEuMi0wLjYtMS4yLTEuMyAwLTAuOCAwLjYtMS41IDEuNC0xLjUgMC43IDAgMS4yIDAuNiAxLjIgMS4zIDAgMC44LTAuNiAxLjQtMS40IDEuNHpNMTYuNiAxNC40Yy0xLjEgMS4xLTEuNiAyLTEuNyAzLjIgMCAwLjItMC4xIDAuNC0wLjEgMC42aC0xLjhjMC0wLjIgMC0wLjQgMC0wLjYgMC4xLTEuMiAwLjctMi41IDIuMS00IDEtMSAxLjktMiAxLjktMy4yIDAtMC44LTAuNC0xLjUtMS43LTEuNS0wLjggMC0xLjYgMC4yLTIuMiAwLjZsLTAuMy0xLjNjMC44LTAuNSAxLjgtMC44IDMtMC44IDIuMSAwIDMuMSAxLjQgMy4xIDIuNyAwIDEuNy0xLjEgMy0yLjQgNC4zeicvPjwvc3ZnPg==';
const ICON_WARNING =
  'PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPSczMicgaGVpZ2h0PSczMicgdmlld0JveD0nMCAwIDMyIDMyJz48cGF0aCBmaWxsPScjZjM5NTM5JyBkPSdNMjYuNCAyMi4yYzEtMS45IDEuNi00IDEuNi02LjMgMC03LjYtNi4yLTEzLjgtMTMuOC0xMy44cy0xMy44IDYuMi0xMy44IDEzLjggNi4yIDEzLjggMTMuOCAxMy44YzMuNSAwIDYuNy0xLjMgOS4yLTMuNWw3LjIgMi00LjEtNS45ek0xMi43IDIyLjZjLTAuNyAwLTEuMi0wLjYtMS4yLTEuMyAwLTAuOCAwLjYtMS41IDEuNC0xLjUgMC43IDAgMS4yIDAuNiAxLjIgMS4zIDAgMC44LTAuNiAxLjQtMS40IDEuNHpNMTQuMSAxOC4xaC0xLjRsMS43LTEwLjVoMi4xbC0yLjMgMTAuNXonLz48L3N2Zz4=';
const ICON_ERROR =
  'PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPSczMicgaGVpZ2h0PSczMicgdmlld0JveD0nMCAwIDMyIDMyJz48cGF0aCBmaWxsPScjYzIxOTM2JyBkPSdNMjYuNCAyMi4yYzEtMS45IDEuNi00IDEuNi02LjMgMC03LjYtNi4yLTEzLjgtMTMuOC0xMy44LTcuNiAwLTEzLjggNi4yLTEzLjggMTMuOHM2LjIgMTMuOCAxMy44IDEzLjhjMy41IDAgNi43LTEuMyA5LjItMy41bDcuMiAyLTQuMS01Ljl6TTE3LjcgMTkuNmgtMi41bC0wLjUtMS4yYy0wLjItMC42LTAuNC0xLTAuNS0xLjRoLTAuMWMtMC4yIDAuNC0wLjQgMC44LTAuOCAxLjNsLTAuOSAxLjRoLTIuNmwzLjQtNC0xLjgtMy44aDIuNWwwLjUgMS4yYzAuMiAwLjYgMC40IDEgMC41IDEuM2gwYzAuMy0wLjQgMC41LTAuOCAwLjgtMS4ybDAuOS0xLjJoMi42bC0zLjMgMy44IDEuOCA0eicvPjwvc3ZnPg==';

const questionSelector = '& div[data-claire-semantic="question"]';
const infoSelector = '& aside[data-claire-semantic="information"]';
const errorSelector = '& aside[data-claire-semantic="error"]';
const warningSelector = '& aside[data-claire-semantic="warning"]';

function semanticIcon(icon) {
  return {
    '&::before': {
      background: `transparent url("data:image/svg+xml;base64,${icon}") 0 0`,
    },
  };
}

export default {
  [`${questionSelector},${infoSelector},${errorSelector},${warningSelector}`]: {
    boxSizing: 'content-box',
    position: 'relative',
    borderRadius: shape.borderRadius,
    margin: '25px 18px 20px 18px',
    padding: '10px 10px 10px 30px',
    minHeight: 'auto',

    '&::before': {
      content: '" "',
      display: 'block',
      position: 'absolute',
      borderRadius: 0,
      width: 30,
      height: 30,
      left: -10,
      top: -10,
      zIndex: 1,
    },

    '&::after': {
      content: '" "',
      background: palette.background.primary,
      display: 'block',
      position: 'absolute',
      width: 24,
      height: 24,
      top: -8,
      left: -8,
      borderRadius: '50%',
    },

    '& p:last-of-type': {
      margin: 0,
    },

    '& *': {
      wordBreak: 'break-word',
    },

    '& a, & a:visited': {
      color: palette.text.linkOnContrasted,
      fontWeight: 'bold',
    },
  },
  [infoSelector]: {
    background: '#e6f4fa',
    ...semanticIcon(ICON_INFORMATION),
  },
  [warningSelector]: {
    background: '#fdefe1',
    ...semanticIcon(ICON_WARNING),
  },
  [errorSelector]: {
    background: '#f9d2d8',
    ...semanticIcon(ICON_ERROR),
  },
  [questionSelector]: {
    background: '#f4f4f4',
    ...semanticIcon(ICON_QUESTION),
  },
};
